
<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col>
              <v-tabs>
                <v-tab>
                  <v-icon left>
                    mdi-receipt
                  </v-icon>Основное
                </v-tab>
                <v-tab>
                  <v-icon left>
                    mdi-receipt
                  </v-icon>Стоимость
                </v-tab>
                <v-tab>
                  <v-icon left>
                    mdi-receipt
                  </v-icon>Дополнительно
                </v-tab>
                <v-tab-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.code"
                        label="Код номенклатуры"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.name"
                        label="Наименование"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="form.client"
                        label="Клиент"
                        :items="clients"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.description"
                        label="Описание"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="form.category"
                        :items="mainCategories"
                        label="Категория"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="form.subcategory"
                        label="Подкатегория"
                        :items="subCategories"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="form.subsubcategory"
                        label="Подподкатегория"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <uploadFiles
                        v-model="form.image"
                        label="Основное изображение"
                        :btn_text="'Загрузить фотографию'"
                        :limit="1"
                        :single="true"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <uploadFiles
                        v-model="form.imageExt"
                        label="Дополнительное изображение"
                        :btn_text="'Загрузить фотографию'"
                        :limit="1"
                        :single="true"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-select
                        v-model="form.type"
                        :items="nomenclatureTypes"
                        label="Тип номенклатуры"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="form.supplier"
                        :items="suppliers"
                        label="Поставщик"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.price"
                        type="number"
                        label="Стоимость"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.cost"
                        type="number"
                        label="Себестоимость"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-select
                        v-model="form.unit"
                        :items="units"
                        label="Единица измерения"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-select
                        v-model="form.tax"
                        :items="taxTypes"
                        label="НДС"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.rest"
                        type="number"
                        label="Остаток"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.in_sale"
                        type="number"
                        label="На реализации"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.minValue"
                        type="number"
                        label="Минимальное значение на точке"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="form.considerBalance"
                        label="Учитывать баланс"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row class="justify-center">
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="form.integration_item"
                        :items="integrations"
                        label="Обработчик"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.product_uuid"
                        type="number"
                        label="Уникальный идентификатор продукта"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.code_ext"
                        type="number"
                        label="Внешний идентификатор"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.plu"
                        type="number"
                        label="Код поиска цены"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="form.productLabelingType"
                        :items="productTypes"
                        label="Тип маркировки"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.gtin"
                        label="GTIN"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="form.age18Check"
                        label="Для 18+"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-around">
          <v-row class="justify-center">
            <v-col
              cols="6"
              lg="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              lg="3"
              class="text-right"
            >
              <v-btn
                v-if="!view"
                color="primary"
                class="ml-auto"
                @click="onSave"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script >
import { JustpayNomenclature } from "@/views/loyalty/shared/services/justpay-nomenclature-service"
import moment from "moment/moment"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"

export default {
  props: ['create', 'change', 'view', 'show', 'item'],
  data: () => ({
    categories: [],
    clients: [],
    form: {
      code: '',
      name: '',
      description: '',
      category: '',
      subcategory: '',
      subsubcategory: '',
      type: 0,
      price: 0,
      cost: 0,
      unit: 0,
      tax: 0,
      rest: 0,
      in_sale: 0,
      supplier: '',
      product_uuid: '',
      code_ext: '',
      minValue: 0,
      plu: '',
      image: {}

    },
    integrations: [],
    justpayClientService: null,
    justpayNomenclatureService: null,
    nomenclatureTypes: [],
    mainCategories: [],
    points: [],
    productTypes: [],
    subCategories: [],
    subSubCategories: [],
    suppliers: [],
    taxTypes: [],
    units: []
  }),
  watch: {
    'form.category': function () {
      if (this.categories) {
        this.subCategories = this.categories.filter(f => this.mainCategories.some(s => s.value === f.group && s.value === this.form.category))
        this.subSubCategories = this.categories.filter(f => this.mainCategories.every(s => s.value !== f.group) && this.subCategories.every(s => s.value !== f.group))
      }
}
  },
  beforeMount () {
    this.justpayClientService = new JustpayClient()
    this.justpayNomenclatureService = new JustpayNomenclature()
  },
  async mounted () {
    let response = {}
    const nomenclatureId = this.$route.query.id
    response = await this.justpayNomenclatureService.getNomenclatureList({ id: nomenclatureId })
    if (nomenclatureId) {
      console.log('response', response)
      if (response.data.length > 0) {
        this.form = response.data[0]
      }
    }
    this.clients = response.clients
    this.categories = response.categories
    this.integrations = response.integrations
    this.nomenclatureTypes = response.nomenclatureTypes
    this.productTypes = response.productTypes
    this.suppliers = response.suppliers
    this.taxTypes = response.taxTypes
    this.units = response.units
    this.mainCategories = this.categories.filter(f => f.group == null)
    this.subCategories = this.categories.filter(f => this.mainCategories.some(s => s.value === f.group && s.value === this.form.category))
    this.subSubCategories = this.categories.filter(f => this.mainCategories.every(s => s.value !== f.group) && this.subCategories.every(s => s.value !== f.group))
  },
  methods: {
    formatDateTime: function (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    async onSave () {
      if (this.form.id) {
        await this.justpayNomenclatureService.changeNomenclature(this.form)
      } else {
        await this.justpayNomenclatureService.createNomenclature(this.form)
      }
      this.$router.go(-1)
    }
  },
}
</script>

<style scoped>

</style>
